export const hlsErrorIds = {
  manifestLoadError: 'Rabbit',
  manifestLoadTimeOut: 'Chinchilla',
  manifestParsingError: 'Hedgehog',
  levelLoadError: 'Mandrill',
  fragLoadError: 'Zebra',
  fragLoadTimeOut: 'Vicuna',
  keyLoadTimeOut: 'Capybara',
  manifestIncompatibleCodecsError: 'Reindeer',
  fragDecryptError: 'Chameleon',
  fragParsingError: 'Wolf',
  bufferAppendError: 'Panda',
  bufferStalledError: 'Moose',
  bufferNudgeOnStall: 'Lizard',
  internalException: 'Wildcat',
};
